export enum PathName {
  phones = '/phones',
  tablets = '/tablets',
  accessories = '/accessories',
  favourites = '/favourites',
}
